'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('../utils');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      staticClass: "badge"
    }, [!_vm.count && !_vm.text.trim() ? _c('span', {
      staticClass: "badge-item badge-item-dot"
    }) : _vm.count ? _c('span', {
      staticClass: "badge-item badge-item-number"
    }, [_vm._v(" " + _vm._s(_vm.count > _vm.maxCount ? "".concat(_vm.maxCount, "+") : _vm.count) + " ")]) : _vm.text ? _c('span', {
      staticClass: "badge-item badge-item-bubble"
    }, [_vm._v(" " + _vm._s(_vm.text) + " ")]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2);
  },
  staticRenderFns: [],
  name: 'badge',
  props: {
    count: {
      type: Number,
      default: 0
    },
    text: {
      type: String,
      default: ''
    },
    maxCount: {
      type: Number,
      default: 999
    }
  }
});

exports.default = index;
